var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001246",
    d: "M10.41 7.599l-.858-.76a.435.435 0 01.573-.651l1.666 1.473a.434.434 0 01.209.372.436.436 0 01-.147.335l-1.728 1.524a.435.435 0 01-.572-.652l.876-.773H10.1c-1.98 0-3.022-.724-4.588-2.754C3.947 7.743 2.906 8.467.926 8.467H.433a.434.434 0 010-.868h.493c1.69 0 2.551-.632 4.045-2.606C3.477 3.02 2.616 2.388.926 2.388H.433a.434.434 0 010-.868h.493c1.98 0 3.021.724 4.587 2.754C7.08 2.244 8.121 1.52 10.101 1.52h.31L9.55.76a.435.435 0 01.574-.651l1.666 1.473a.434.434 0 01.209.372.436.436 0 01-.147.335l-1.728 1.523a.435.435 0 01-.572-.652l.876-.772H10.1c-1.69 0-2.552.632-4.046 2.605C7.55 6.967 8.411 7.6 10.101 7.6h.31z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.db622dd42dc9a077f19136b229559e89.svg";
export { ForwardRef as ReactComponent };